// Real Google reviews — EpoxyArt33 Google Business Profile (5.0 rating)
export const GOOGLE_REVIEW_URL = 'https://g.page/r/CS9tqGDQygtDEBM/review';
export const GOOGLE_RATING = { value: '5.0', count: 17 };

export const googleReviews = [
  {
    id: 'suzanna-bedy',
    name: 'Suzanna Bedy',
    rating: 5,
    text: 'Arrived on time as scheduled, was extremely professional throughout the entire process, and garage floor looks amazing. Would highly, highly recommend!',
    project: 'Garage Floor Coating',
  },
  {
    id: 'phil-dinunzio',
    name: 'Phil DiNunzio',
    rating: 5,
    text: 'Our pool deck was a mess! We had low spots that gathered water and mildew, as well as large cracks that made keeping it clean impossible. EpoxyArt33 transformed it.',
    project: 'Pool Deck Resurfacing',
  },
  {
    id: 'silvio-diaz',
    name: 'Silvio Diaz',
    rating: 5,
    text: 'Best experience ever. Good communication with Luis the entire time, with updates and questions answered in real time.',
    project: 'Garage Floor Coating',
  },
  {
    id: 'a-c',
    name: 'A C',
    rating: 5,
    text: 'Wow, wow, wow! This is a great company!! The owner, Luis, responded right away to my inquiry, and got me on his schedule.',
    project: 'Epoxy Flooring',
  },
  {
    id: 'peter-esdale',
    name: 'Peter Esdale',
    rating: 5,
    text: 'Luis, owner of Epoxy Art and staff did a fantastic job epoxying my garage floor! I would highly recommend their company.',
    project: 'Garage Floor Coating',
  },
  {
    id: 'anthony-ramirez',
    name: 'Anthony Ramirez',
    rating: 5,
    text: "Hired the team at Epoxy Art to do an epoxy coating in my garage, and I couldn't be happier with the result.",
    project: 'Garage Epoxy Coating',
  },
  {
    id: 'jerry-spuzzillo',
    name: 'Jerry Spuzzillo',
    rating: 5,
    text: 'Great job Epoxy Art33 did for us. They were professional and cleaned up job site meticulously.',
    project: 'Garage Floor Coating',
  },
  {
    id: 'tom-sheahen',
    name: 'Tom Sheahen',
    rating: 5,
    text: 'After getting multiple quotes on resurfacing our pool deck we decided to go with EpoxyArt33.',
    project: 'Pool Deck Resurfacing',
  },
];
